import React from "react";
import WhoWeAreHeader from "../../components/WhoWeAreHeader/WhoWeAreHeader";
import Footer from "../../components/Footer/Footer";
import Menu from "../../components/Menu/Menu";
import AboutSection from "../../components/AboutSection/AboutSection";
import NewSection from "../../components/NewSection/NewSection";
// import "./WhoWeAre.css";

const WhoWeAre = () => {
  return (
    <>
      <WhoWeAreHeader />
      <Menu />
      <main>
        <NewSection />

        <AboutSection />
      </main>
      <Footer />
    </>
  );
};

export default WhoWeAre;
